module.exports = __webpack_public_path__ + "img/syukyaku-de-002.eb070a1b.jpg";